//src/components/admin/CommunicationCenter

import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef
} from "react";

import api from "../../api/api";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import ImageZoomModal from "../ui/ImageZoomModal";

// MODAIS
import CreateAdvancedThreadModal from "./CreateAdvancedThreadModal";
import CreatePublicationModal from "./CreatePublicationModal";
import CreateGalleryModal from "./CreateGalleryModal";

// Ícones
const StarIcon = ({ filled }) => <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ${filled ? 'text-yellow-500' : 'text-gray-300'}`} viewBox="0 0 20 20" fill="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.81 2.035a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.81-2.035a1 1 0 00-1.175 0l-2.81 2.035c-.784.57-1.84-.197-1.54-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.004 8.72c-.784-.57-.383-1.81.588-1.81h3.461a1 1 0 00.95-.69l1.07-3.292z" /></svg>;
const ReviewsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M11.05 15.05a1.5 1.5 0 00-2.12 0l-3.5 3.5a1.5 1.5 0 000 2.12l3.5 3.5a1.5 1.5 0 002.12 0l3.5-3.5a1.5 1.5 0 000-2.12l-3.5-3.5zM12 21h7a2 2 0 002-2v-7M5 12V5a2 2 0 012-2h10a2 2 0 012 2v7M5 12h14" /></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m-4-6h4m4-6H5" /></svg>;
const SendIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 00.183.654A1 1 0 004 18h12a1 1 0 00.923-.654 1 1 0 00.183-.654l-7-14z" /></svg>;
const BlockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" /></svg>;
const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>;
const SettingsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37a1.724 1.724 0 002.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
</svg>;

const DesignIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
</svg>;

// =====================================================
// COMPONENTE AUXILIAR 1: ImageGroup (Galeria com Zoom)
// =====================================================
function ImageGroup({ attachments }) {
  const [zoomSrc, setZoomSrc] = useState(null);

  const images = useMemo(() => {
    return attachments.filter(a => {
      const mime = a.file_mime || a.mime;
      const url = a.file_url || a.url || a.filepath;
      return (
        mime?.startsWith("image/") ||
        url?.match(/\.(jpg|jpeg|png|gif|webp)$/i)
      );
    });
  }, [attachments]);

  if (images.length === 0) return null;

  return (
    <>
      <div className="grid grid-cols-3 gap-2 mt-2 max-w-sm">
        {images.map((img, i) => {
          const src = img.file_url || img.filepath;
          return (
            <img
              key={i}
              src={src}
              alt={`Anexo ${i}`}
              className="rounded-lg w-full h-32 object-cover cursor-zoom-in hover:scale-[1.03] transition shadow"
              onClick={() => setZoomSrc(src)}
            />
          );
        })}
      </div>

      {zoomSrc && (
        <ImageZoomModal
          src={zoomSrc}
          onClose={() => setZoomSrc(null)}
        />
      )}
    </>
  );
}

// =====================================================
// COMPONENTE AUXILIAR 2: MessageBubble (Estilo WhatsApp)
// =====================================================
function MessageBubble({ children, isSentByCurrentUser, senderName, sentAt }) {
  const containerAlign = isSentByCurrentUser ? "justify-end" : "justify-start";

  const bubbleBase =
    "relative max-w-[75%] px-4 py-2 text-sm leading-relaxed shadow";

  const sentBubble =
    "bg-indigo-600 text-white rounded-2xl rounded-br-sm ml-auto";

  const receivedBubble =
    "bg-gray-100 text-gray-800 rounded-2xl rounded-bl-sm mr-auto";

  const nameStyle = isSentByCurrentUser
    ? "text-indigo-200"
    : "text-indigo-600";

  const timeStyle = isSentByCurrentUser
    ? "text-indigo-300"
    : "text-gray-500";

  return (
    <div className={`flex ${containerAlign} w-full`}>
      <div className={`${bubbleBase} ${isSentByCurrentUser ? sentBubble : receivedBubble}`}>
        
        {/* Header */}
        <div className="flex items-center justify-between mb-1 gap-3">
          <span className={`text-xs font-semibold ${nameStyle}`}>
            {senderName}
          </span>
          <span className={`text-[10px] whitespace-nowrap ${timeStyle}`}>
            {sentAt}
          </span>
        </div>

        {/* Conteúdo */}
        <div className="break-words whitespace-pre-wrap">
          {children}
        </div>

        {/* Rabinho da bolha */}
        <span
          className={`absolute bottom-0 ${
            isSentByCurrentUser
              ? "-right-1 border-l-indigo-600"
              : "-left-1 border-r-gray-100"
          } w-0 h-0 border-t-8 border-b-8 ${
            isSentByCurrentUser
              ? "border-l-8 border-t-transparent border-b-transparent"
              : "border-r-8 border-t-transparent border-b-transparent"
          }`}
        />
      </div>
    </div>
  );
}

// =====================================================
// COMPONENTE PRINCIPAL: CommunicationCenter
// =====================================================

export default function CommunicationCenter({ setNotification }) {
  const [tab, setTab] = useState("reviews");
  const audioRef = useRef(null);
  // DADOS
  const [threads, setThreads] = useState([]);
  const [messages, setMessages] = useState([]);
  const [contactMessages, setContactMessages] = useState([]);
  const [emailLogs, setEmailLogs] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [lessonReviews, setLessonReviews] = useState([]);
  const [courseCommentSettings, setCourseCommentSettings] = useState([]);

  // PREVIEW
  const [previewThreadMsgs, setPreviewThreadMsgs] = useState(null);
  const [previewContact, setPreviewContact] = useState(null);
  const [previewChatMsg, setPreviewChatMsg] = useState(null);
  const [previewReview, setPreviewReview] = useState(null);

  // FORM
  const [replyMessage, setReplyMessage] = useState("");
  const [contactReplyMessage, setContactReplyMessage] = useState("");
  const [chatReplyMessage, setChatReplyMessage] = useState("");
  const [reviewReplyMessage, setReviewReplyMessage] = useState("");
  const [globalSettings, setGlobalSettings] = useState({});
  const [emailTemplates, setEmailTemplates] = useState([]);

  // UI
  const [loading, setLoading] = useState(false);
  const [showNewThreadModal, setShowNewThreadModal] = useState(false);
  const [showNewPublicationModal, setShowNewPublicationModal] = useState(false);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [galleryPhotos, setGalleryPhotos] = useState([]);
  const [previewGalleryIndex, setPreviewGalleryIndex] = useState(null);

  
    // PUBLICAÇÕES
  const [publications, setPublications] = useState([]);
  const [previewPublication, setPreviewPublication] = useState(null);
  const [publicationToEdit, setPublicationToEdit] = useState(null);

  // Função para abrir o modal em modo edição
  const handleEditPublication = (pub) => {
   setPublicationToEdit(pub);
   setShowNewPublicationModal(true);
  };
  const [photoToEdit, setPhotoToEdit] = useState(null);
  // ESTADO DO MODAL DE AÇÃO (CONFIRMAÇÃO)
  const [actionModal, setActionModal] = useState({
    show: false,
    actionType: null, // 'DELETE_THREAD', 'DELETE_CONTACT', 'TOGGLE_COURSE', 'BLOCK_REVIEW', 'DELETE_REVIEW', 'DELETE_LOG', 'SMTP_ERROR', 'DELETE_MSG'
    modalTitle: "",
    modalContent: "",
    confirmVariant: "danger", // 'danger', 'primary', 'warning'
    data: null, // Objeto genérico para passar IDs ou parâmetros
  });

  const currentUser = JSON.parse(localStorage.getItem("user")) || {};
  const currentUserId = currentUser.id;
  const currentUserRole = currentUser.role;

  // REFS PARA CONTROLE DE ATUALIZAÇÃO SEM RE-RENDER INFINITO
  const lastUnreadCount = useRef(0);
  const lastThreadsCount = useRef(0);
  const lastReviewsCount = useRef(0);

  
  // =====================================================
  // LÓGICA GALERIA
  // =====================================================
 const loadGallery = useCallback(async () => {
 try {
  const res = await api.get("/galleries/admin", {
   headers: {
    "Cache-Control": "no-cache",
    "Pragma": "no-cache"
   },
   params: {
    _: Date.now() // 🔥 quebra cache
   }
  });

  // 🔒 normaliza retorno (garante array)
  const photos = Array.isArray(res.data?.data)
   ? res.data.data
   : Array.isArray(res.data)
   ? res.data
   : [];

  setGalleryPhotos(photos);

 } catch (err) {
  console.error("❌ Erro ao carregar galeria:", err);
  setGalleryPhotos([]); // evita estado quebrado
 }
}, []);

  
 // ADICIONE ESTA FUNÇÃO AQUI (perto dos outros handlers como handleReplyToChat)
  const updateGalleryDesign = async (mode) => {
    try {
      // Aqui enviamos para o seu endpoint de configurações
      await api.patch("/settings/update-bulk", { GALLERY_DESIGN_MODE: mode });
      setGlobalSettings(prev => ({ ...prev, GALLERY_DESIGN_MODE: mode }));
      setNotification({ show: true, type: "success", message: "Design da Home atualizado!" });
    } catch (err) {
      setNotification({ show: true, type: "error", message: "Erro ao salvar preferência." });
    }
  };
  
 // =====================================================
  // LÓGICA DO FÓRUM 
  // =====================================================
   const loadForumThreads = async () => {
     const res = await api.get("/forum/threads?_=" + Date.now());
     const incoming = res.data;
     
     // 🔥 Atualiza o tópico aberto automaticamente se houver mudança no timestamp
     if (previewThreadMsgs?.id) {
       const activeThread = incoming.find(t => t.id === previewThreadMsgs.id);
       const oldThread = threads.find(t => t.id === previewThreadMsgs.id);
       if (activeThread && oldThread && activeThread.updated_at !== oldThread.updated_at) {
        previewForumThread(activeThread.id);
       }
     }

     // Som para novo tópico
     if (incoming.length > lastThreadsCount.current && lastThreadsCount.current !== 0) {
       audioRef.current?.play().catch(() => {});
       setNotification({ show: true, type: "info", message: "🗣️ Novo tópico no fórum!" });
     }
     lastThreadsCount.current = incoming.length;
     setThreads(incoming);
    };


       // =====================================================
      // PREVIEW DE TÓPICO DO FÓRUM
      // =====================================================
     const previewForumThread = async (id) => {
      try {
        const res = await api.get(`/forum/thread/${id}`);
     
        const normalizeAttachment = (a) => ({
          ...a,
          file_url: a.file_url || a.url || a.filepath,
          file_mime: a.file_mime || a.mime
        });
     
        setPreviewThreadMsgs({
          id: res.data.thread.id,
          title: res.data.thread.title,
          content: res.data.thread.content,
          status: res.data.thread.status,
          attachments: (res.data.attachments || []).map(normalizeAttachment),
          replies: (res.data.replies || []).map(r => ({
            ...r,
            attachments: (r.attachments || []).map(normalizeAttachment)
          }))
        });
     
      } catch (e) {
        console.error(e);
        setNotification({
          show: true,
          type: "error",
          message: "Erro ao abrir tópico"
        });
      }
    };

       
      const handleReplyToForum = async () => {
      if (!replyMessage.trim() || !previewThreadMsgs?.id) return;
     
      try {
        await api.post(
          `/forum/thread/${previewThreadMsgs.id}/reply`,
          { content: replyMessage }
        );
     
        setReplyMessage("");
        previewForumThread(previewThreadMsgs.id);
      } catch (error) {
        setNotification({
          show: true,
          type: "error",
          message: "Erro ao enviar resposta"
        });
      }
    };

  // =====================================================
  // UTILS
  // =====================================================

  const formatDate = (d) => {
    if (!d) return "Sem Última Msg";
    const date = new Date(d);
    if (isNaN(date)) return "Data Inválida";
    return format(date, "dd/MM/yyyy HH:mm", { locale: ptBR });
  }

  // 🔥🔥🔥 FUNÇÃO DE ESTILO DAS ABAS (CORRIGIDA) 🔥🔥🔥
  const tabClass = (t) => `flex items-center gap-2 px-5 py-3 rounded-2xl cursor-pointer font-bold transition-all duration-300 border ${
    tab === t 
      ? "bg-indigo-600 text-white shadow-xl shadow-indigo-200 border-indigo-600 transform scale-105 z-10" 
      : "bg-white text-indigo-900 border-indigo-100 hover:bg-indigo-50 hover:border-indigo-200 hover:text-indigo-700" 
  }`

  const renderAttachmentPreview = (attachment) => {
    const url = attachment.file_url || attachment.filepath;
    const mime = attachment.file_mime || attachment.mime;
    if (!url) return null;
    if (mime?.includes("image") || url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) return null;
    const fileName = attachment.filename || 'Arquivo Anexo';
    if (mime?.includes("pdf") || url.endsWith(".pdf"))
      return (
        <div className="mt-2 space-y-2">
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-red-600 underline block text-sm font-medium hover:text-red-800">📄 {fileName} (Abrir PDF)</a>
          <div className="border border-gray-400 rounded-lg overflow-hidden">
            <iframe src={url} className="w-full" style={{ minHeight: "200px", border: "none" }} title="Preview PDF"></iframe>
          </div>
        </div>
      )
    return <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline block mt-2 text-sm font-medium">📁 {fileName}</a>
  }

  const renderRatingStars = (currentRating) => {
    return (
      <div className="flex">
        {Array.from({ length: 5 }).map((_, index) => (
          <StarIcon key={index} filled={index * 2 < currentRating} />
        ))}
      </div>
    );
  };

  const currentThreadId = previewThreadMsgs?.[0]?.thread_id || null;
  const currentThread = threads.find(t => t.id === currentThreadId);

  const previewContactMessage = (msg) => {
    setPreviewContact(msg);
    setContactReplyMessage("");
  };

 const previewChatMessage = async (chat) => {
 setPreviewChatMsg(chat);
 setChatReplyMessage("");
 setLoading(true);

 try {
  const res = await api.get(`/chat/threads/${chat.id}/messages`);
  setChatHistory(res.data?.data || []);
 } catch {
  setChatHistory([]);
 } finally {
  setLoading(false);
 }
};


const handleReplyToChat = async (chatId) => {
 if (!chatReplyMessage.trim()) return;

 const message = chatReplyMessage;
 setChatReplyMessage("");

 try {
  await api.post(
   `/chat/threads/${chatId}/messages`,
   { message }
  );

  // 🔥 atualiza localmente SEM esperar polling
  setChatHistory(prev => [
   ...prev,
   {
    id: `temp-${Date.now()}`,
    message,
    from_admin: 1,
    sent_at: new Date().toISOString()
   }
  ]);

 } catch {
  setNotification({
   show: true,
   type: "error",
   message: "Erro ao enviar mensagem."
  });
 }
};

const chatEndRef = useRef(null);

useEffect(() => {
 chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [chatHistory.length]);


useEffect(() => {
 if (tab === "gallery" && galleryPhotos.length === 0) {
  loadGallery();
 }
}, [tab, loadGallery, galleryPhotos.length]);



const getUserLabel = (name, role) => {
  if (!role) return name || "Usuário";

  const map = {
    admin: "Admin",
    professor: "Professor",
    supervisor: "Supervisora",
    user: "Aluno"
  };

  return `${map[role] || "Usuário"} (${name})`;
};


const canEdit = (msg) =>
  msg.user_id === currentUserId || currentUserRole === "admin";

const canDelete = (msg) =>
  msg.user_id === currentUserId || currentUserRole === "admin";

const canBlock = () =>
  currentUserRole === "admin";

  // =====================================================
  // LOADERS
  // =====================================================

  
  const previewThread = async (id) => {
    try { const res = await api.get(`/admin/threads/${id}/messages`); setPreviewThreadMsgs(res.data?.data || []); } catch {
      setNotification({ show: true, type: "error", message: "Erro ao carregar mensagens" });
    }
  };

   const loadChatMessages = async () => {
    try {
      const res = await api.get(`/chat/threads?_=${Date.now()}`);
      const newChats = res.data?.data || [];
      
      // 🔥 Lógica de Som e Toast para Chat
      const currentTotalUnread = newChats.reduce((a, b) => a + (b.unread_count || 0), 0);
      if (currentTotalUnread > lastUnreadCount.current && messages.length > 0) {
        audioRef.current?.play().catch(() => {});
        setNotification({ show: true, type: "info", message: "💬 Nova mensagem no chat!" });
      }
      lastUnreadCount.current = currentTotalUnread;
      setMessages(newChats);

      // 🔥 Atualiza a conversa aberta se houver mensagem nova nela
      if (previewChatMsg?.id) {
        const resHistory = await api.get(`/chat/threads/${previewChatMsg.id}/messages?_=${Date.now()}`);
        const incoming = resHistory.data?.data || [];
        if (incoming.length !== chatHistory.length) {
          setChatHistory(incoming);
        }
      }
    } catch { setMessages([]); }
  };


  const loadContactMessages = async () => {
    try { const res = await api.get("/contact"); setContactMessages(res.data?.data || []); } catch { }
  };

  const loadEmailLogs = async () => {
    try { const res = await api.get("/email/logs"); setEmailLogs(res.data?.data || []); } catch { setEmailLogs([]); }
  };

  const loadEmailTemplates = async () => {
    try { const res = await api.get("/email/templates"); setEmailTemplates(res.data || []); } catch { }
  };

const loadGlobalSettings = useCallback(async () => {
  try {
    // 1. Busca dados do backend
    const res = await api.get(`/settings/public?_=${Date.now()}`);
    
    // 2. Prepara objeto para normalização
    let rawSettings = {};
    const normalizedSettings = {};

    // 3. Detecta o formato da resposta (Array ou Objeto)
    if (Array.isArray(res.data)) {
      // Formato [{key: '...', value: '...'}, ...]
      res.data.forEach(item => {
        const key = item.key || item.name;
        const val = item.value || item.content;
        if (key) rawSettings[key] = val;
      });
    } else if (res.data?.data && Array.isArray(res.data.data)) {
       // Formato Laravel Pagination ou Wrapper: { data: [...] }
       res.data.data.forEach(item => {
        const key = item.key || item.name;
        const val = item.value || item.content;
        if (key) rawSettings[key] = val;
      });
    } else if (res.data?.data && typeof res.data.data === 'object') {
       // Formato { data: { KEY: VAL } }
       rawSettings = res.data.data;
    } else {
       // Formato direto { KEY: VAL }
       rawSettings = res.data || {};
    }

    // 4. NORMALIZAÇÃO: Converte todas as chaves para MAIÚSCULO
    // Isso resolve o problema de case-sensitivity (ex: gallery_design_mode vs GALLERY_DESIGN_MODE)
    Object.keys(rawSettings).forEach(key => {
      if (key && rawSettings[key] !== null) {
        normalizedSettings[key.toUpperCase()] = rawSettings[key];
      }
    });

    console.log("🔍 Configurações carregadas (Normalizadas):", normalizedSettings);

    // 5. Atualiza o estado com garantia de fallback
    setGlobalSettings(prev => ({
      ...prev,
      // Agora acessamos tudo em MAIÚSCULO garantido
      SITE_BACKGROUND_COLOR: normalizedSettings.SITE_BACKGROUND_COLOR || "#f8fafc",
      GALLERY_DESIGN_MODE: normalizedSettings.GALLERY_DESIGN_MODE || "slider"
    }));

  } catch (err) {
    console.error("❌ Erro ao carregar configurações:", err);
  }
}, []);



  const loadLessonComments = async () => {
    try {
      const res = await api.get("/lessons/admin/reviews");
      const news = res.data?.data || [];
      if (news.length > lastReviewsCount.current && lastReviewsCount.current !== 0) {
        audioRef.current?.play().catch(() => {});
        setNotification({ show: true, type: "info", message: "🔔 Nova avaliação recebida!" });
      }
      lastReviewsCount.current = news.length;
      setLessonReviews(news);
    } catch { setLessonReviews([]); }
  };

  const loadCourseCommentSettings = async () => {
    try { const res = await api.get("/courses/admin/comment-settings"); setCourseCommentSettings(res.data?.data || []); } catch { setCourseCommentSettings([]); }
  };

// 1. CARGA INICIAL
useEffect(() => {
 loadChatMessages();
 loadForumThreads();
 loadLessonComments();
 loadCourseCommentSettings();
 loadPublications();
 loadContactMessages();
 loadEmailLogs();
}, []);

// 2. POLLING GLOBAL (MONITORAMENTO EM TEMPO REAL)
useEffect(() => {
 const interval = setInterval(() => {
   // Monitora tudo silenciosamente independente da aba
   loadChatMessages();
   loadForumThreads();
   loadLessonComments();
 }, 5000); // 5 segundos

 return () => clearInterval(interval);
}, [previewChatMsg?.id, chatHistory.length, previewThreadMsgs?.id, threads]);



const loadPublications = useCallback(async () => {
 try {
  const res = await api.get("/admin/publications", {
   headers: { "Cache-Control": "no-cache" }
  });

  if (Array.isArray(res.data?.data)) {
   setPublications(res.data.data);
  }
 } catch (error) {
  console.error("Erro ao carregar publicações:", error);
 }
}, []);
  // =====================================================
  // HANDLERS DE AÇÕES (ABREM O MODAL)
  // =====================================================

  const confirmToggleCourseComments = (courseId, currentStatus) => {
    const action = currentStatus === 1 ? 'desativar' : 'ativar';
    setActionModal({
      show: true,
      actionType: 'TOGGLE_COURSE',
      modalTitle: `Confirmar Alteração`,
      modalContent: `Deseja realmente ${action} os comentários para o curso #${courseId}?`,
      confirmVariant: currentStatus === 1 ? "danger" : "primary",
      data: { courseId, currentStatus }
    });
  };

  const confirmDeleteLog = (logId) => {
    setActionModal({
      show: true,
      actionType: 'DELETE_LOG',
      modalTitle: "Excluir Log",
      modalContent: `Deseja excluir permanentemente o log de e-mail #${logId}?`,
      confirmVariant: "danger",
      data: { logId }
    });
  };

  const confirmDeleteContact = (messageId) => {
    setActionModal({
      show: true,
      actionType: 'DELETE_CONTACT',
      modalTitle: "Excluir Mensagem",
      modalContent: "Tem certeza que deseja excluir esta mensagem de contato? Esta ação não pode ser desfeita.",
      confirmVariant: "danger",
      data: { messageId }
    });
  };

  const confirmDeleteThread = (threadId) => {
    setActionModal({
      show: true,
      actionType: 'DELETE_THREAD',
      modalTitle: "Excluir Tópico",
      modalContent: "Deseja excluir o tópico inteiro? Todas as mensagens vinculadas serão removidas permanentemente.",
      confirmVariant: "danger",
      data: { threadId }
    });
  };

  const confirmDeleteReview = (reviewId) => {
    setActionModal({
      show: true,
      actionType: 'DELETE_REVIEW',
      modalTitle: "🚨 Exclusão Permanente",
      modalContent: `Tem certeza que deseja EXCLUIR PERMANENTEMENTE a avaliação #${reviewId} e todas as suas respostas?`,
      confirmVariant: "danger",
      data: { reviewId }
    });
  };

  const confirmBlockReview = (reviewId, isCurrentlyActive) => {
    const action = isCurrentlyActive ? 'bloquear' : 'ativar';
    setActionModal({
      show: true,
      actionType: 'BLOCK_REVIEW',
      modalTitle: `${isCurrentlyActive ? 'Bloquear' : 'Ativar'} Avaliação`,
      modalContent: `Deseja alterar a visibilidade da avaliação #${reviewId}?`,
      confirmVariant: isCurrentlyActive ? "danger" : "primary",
      data: { reviewId, block: isCurrentlyActive }
    });
  };

  const confirmDeleteMessage = (msg, type) => {
    setActionModal({
      show: true,
      actionType: 'DELETE_MSG',
      modalTitle: "Excluir Mensagem",
      modalContent: "Deseja excluir esta mensagem específica?",
      confirmVariant: "danger",
      data: { messageId: msg.id, messageType: type, threadId: msg.thread_id }
    });
  };


// =====================================================
// EXECUTORES DAS AÇÕES (CHAMADOS PELO MODAL)
// =====================================================
const handleActionConfirm = async () => {
  const { actionType, data } = actionModal;

  try {
    // 🎨 DESIGN E IDENTIDADE VISUAL (Caso novo para a aba Design)
if (actionType === 'UPDATE_DESIGN') {
    // Envia para API
    await api.patch("/settings/update-bulk", data.payload);
    
    // Atualiza visualmente NA HORA (para não precisar de refresh)
    setGlobalSettings(prev => ({
        ...prev,
        ...data.payload
    }));
    
    setNotification({ show: true, type: "success", message: "Design atualizado!" });
    
    // Opcional: Recarrega do servidor para garantir consistência
    // loadGlobalSettings(); 
}

    // 🎓 CURSOS
    else if (actionType === 'TOGGLE_COURSE') {
      const newStatus = data.currentStatus === 1 ? 0 : 1;
      await api.patch(`/courses/${data.courseId}/comment-status`, { comments_enabled: newStatus });
      setNotification({ show: true, type: "success", message: "Status do curso atualizado!" });
      loadCourseCommentSettings();
    }

    // 📧 EMAIL LOG
    else if (actionType === 'DELETE_LOG') {
      await api.delete(`/email/logs/${data.logId}`);
      setNotification({ show: true, type: "success", message: "Log removido" });
      loadEmailLogs();
    }

    // 👤 CONTATO
    else if (actionType === 'DELETE_CONTACT') {
      await api.delete(`/contact/${data.messageId}`);
      setPreviewContact(null);
      setNotification({ show: true, type: "success", message: "Mensagem removida." });
      loadContactMessages();
    }

    // 🗣️ FÓRUM – EXCLUIR TÓPICO
    else if (actionType === 'DELETE_THREAD') {
      await api.delete(`/forum/thread/${data.threadId}`);
      setThreads(prev => prev.filter(t => t.id !== data.threadId));
      setPreviewThreadMsgs(null);
      setNotification({ show: true, type: "success", message: "Tópico excluído com sucesso" });
    }

    // 🗣️ FÓRUM – BLOQUEAR TÓPICO
    else if (actionType === 'BLOCK_THREAD') {
      await api.patch(`/forum/thread/${data.threadId}/status`, { status: "blocked" });
      setNotification({ show: true, type: "success", message: "Tópico bloqueado com sucesso" });
      previewForumThread(data.threadId);
      loadForumThreads();
    }

    // 📷 GALERIA
    else if (actionType === 'DELETE_GALLERY') {
      await api.delete(`/galleries/admin/${data.id}`);
      setGalleryPhotos(p => p.filter(photo => photo.id !== data.id));
      setNotification({ show: true, type: "success", message: "Removido da galeria!" });
    } 

    // 📚 PUBLICAÇÕES (Artigos)
    else if (actionType === 'DELETE_PUBLICATION') {
      await api.delete(`/admin/publications/${data.id}`);
      setPublications(prev => prev.filter(p => p.id !== data.id));
      if (previewPublication?.id === data.id) setPreviewPublication(null);
      setNotification({ show: true, type: "success", message: "Publicação excluída com sucesso!" });
    }

    // ⭐ AVALIAÇÕES (Reviews de aulas)
    else if (actionType === 'DELETE_REVIEW') {
      await api.delete(`/lessons/admin/comments/${data.reviewId}`);
      setPreviewReview(null);
      setNotification({ show: true, type: "success", message: "Avaliação excluída." });
      loadLessonComments();
    }

    else if (actionType === 'BLOCK_REVIEW') {
      const newStatus = data.block ? 0 : 1;
      await api.patch(`/lessons/admin/comments/${data.reviewId}/status`, { is_active: newStatus });
      setNotification({ show: true, type: "success", message: "Status da avaliação alterado." });
      loadLessonComments();
      if (previewReview?.id === data.reviewId) {
        setPreviewReview(prev => ({ ...prev, is_active: newStatus }));
      }
    }

    // 💬 CHAT – BLOQUEAR / DESBLOQUEAR
    else if (actionType === 'TOGGLE_CHAT_BLOCK') {
      await api.patch(`/chat/threads/${data.chatId}/block`, { blocked: data.blocked });
      setNotification({
        show: true,
        type: "success",
        message: data.blocked ? "Chat bloqueado com sucesso." : "Chat desbloqueado com sucesso."
      });
      if (previewChatMsg?.id === data.chatId) {
        setPreviewChatMsg(prev => ({ ...prev, is_blocked: data.blocked ? 1 : 0 }));
      }
      loadChatMessages();
    }

    // 💬 CHAT – EXCLUIR MENSAGEM OU CONVERSA
    else if (actionType === 'DELETE_CHAT_MSG') {
      await api.delete(`/chat/messages/${data.messageId}`);
      setNotification({ show: true, type: "success", message: "Mensagem removida." });
      if (previewChatMsg?.id) await previewChatMessage(previewChatMsg);
    }

    else if (actionType === 'DELETE_CHAT_THREAD') {
      await api.delete(`/chat/threads/${data.chatId}`);
      setPreviewChatMsg(null);
      setChatHistory([]);
      setNotification({ show: true, type: "success", message: "Conversa excluída." });
      loadChatMessages();
    }

  } catch (error) {
    console.error("Erro na ação administrativa:", error);
    setNotification({ show: true, type: "error", message: "Erro ao processar solicitação." });
  } finally {
    setActionModal({ show: false });
  }
};


const confirmDeleteGalleryItem = (id) => setActionModal({ show: true, actionType: 'DELETE_GALLERY', modalTitle: "Excluir", modalContent: "Remover foto?", confirmVariant: "danger", data: { id } });
// =====================================================
// OUTRAS AÇÕES DIRETAS E UTILS
// =====================================================


const safeParseContent = (content) => {
 if (!content) return "";
 if (typeof content === "object") return content.value || "";
 if (typeof content === "string") {
  try {
   const parsed = JSON.parse(content);
   return parsed?.value || content;
  } catch {
   return content;
  }
 }
 return "";
};

const handleReplyToContact = async (originalMessage) => {
 if (!contactReplyMessage.trim()) return setNotification({ show: true, type: "warning", message: "Digite uma resposta" });
 const data = {
  recipientEmail: originalMessage.email,
  subject: `RE: ${originalMessage.assunto}`,
  bodyText: contactReplyMessage,
  bodyHtml: `<p>${contactReplyMessage.replace(/\n/g, '<br>')}</p>`,
 };
 try {
  await api.post("/email/send-reply", data);
  setNotification({ show: true, type: "success", message: `E-mail enviado para ${originalMessage.email}!` });
  setContactReplyMessage("");
  loadEmailLogs();
 } catch (error) {
  const smtpError = error.response?.data?.error;
  if (smtpError && smtpError.includes("daily request limit exceeded")) {
   setActionModal({
    show: true,
    actionType: 'SMTP_ERROR',
    modalTitle: "🚨 Limite de Envio Atingido",
    modalContent: "Seu servidor atingiu o limite de envios diários. Tente novamente mais tarde.",
    confirmVariant: "primary"
   });
  } else {
   setNotification({ show: true, type: "error", message: "Falha ao enviar e-mail." });
  }
 }
};

const handleReplyToThread = async (threadId) => {
 if (!replyMessage.trim()) return setNotification({ show: true, type: "warning", message: "Digite uma resposta" });
 try {
  await api.post(`/admin/threads/${threadId}/messages`, { message: replyMessage });
  setReplyMessage("");
  previewThread(threadId);
 } catch { setNotification({ show: true, type: "error", message: "Erro ao responder" }); }
};

const previewReviewMessage = (review) => {
 setPreviewReview(review);
 setReviewReplyMessage(review.reply_message || "");
};

const handleReplyToReview = async (review) => {
 if (!reviewReplyMessage.trim()) return setNotification({ show: true, type: "warning", message: "Digite uma resposta" });
 try {
  const res = await api.post(`/lessons/${review.lesson_id}/comments/${review.id}/reply`, { reply: reviewReplyMessage });
  setNotification({ show: true, type: "success", message: "Resposta enviada!" });
  setReviewReplyMessage("");
  setPreviewReview(prev => ({
   ...prev,
   reply_message: res.data.reply.reply,
   reply_user_name: res.data.reply.user_name,
   reply_sent_at: res.data.reply.sent_at
  }));
  loadLessonComments();
 } catch { setNotification({ show: true, type: "error", message: "Falha ao enviar resposta." }); }
};

function PublicationMedia({ type, url, title }) {
 if (!url) return null;

 // 🔥 CORREÇÃO CRÍTICA: força HTTPS (resolve PDF não abrindo)
 const mediaUrl = String(url).replace(/^http:\/\//i, "https://");

 const isPdf =
  type === "pdf" || mediaUrl.toLowerCase().endsWith(".pdf");

 const isVideo =
  type === "video" ||
  mediaUrl.toLowerCase().endsWith(".mp4") ||
  mediaUrl.toLowerCase().endsWith(".mov") ||
  mediaUrl.toLowerCase().endsWith(".webm");

 const isImage =
  type === "image" ||
  mediaUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i);

 /* ================= PDF ================= */
 if (isPdf) {
  return (
   <div className="relative w-full min-h-[600px] bg-white rounded-xl overflow-hidden border border-gray-200">
    <iframe
     src={`${mediaUrl}#toolbar=0&navpanes=0`}
     title={title}
     className="w-full h-[600px]"
     loading="lazy"
    />
   </div>
  );
 }

 /* ================= YOUTUBE ================= */
 if (type === "youtube") {
  const videoId = mediaUrl.includes("v=")
   ? mediaUrl.split("v=")[1]?.split("&")[0]
   : mediaUrl.split("/").pop();

  return (
   <div className="w-full bg-black flex items-center justify-center">
    <iframe
     src={`https://www.youtube.com/embed/${videoId}`}
     title={title}
     className="w-full aspect-video"
     allowFullScreen
    />
   </div>
  );
 }

 /* ================= VÍDEO ================= */
 if (isVideo) {
  return (
   <div className="w-full bg-black flex items-center justify-center">
    <video
     controls
     preload="metadata"
     className="w-full max-h-[500px]"
    >
     <source src={mediaUrl} type="video/mp4" />
     Seu navegador não suporta a reprodução de vídeos.
    </video>
   </div>
  );
 }

 /* ================= IMAGEM ================= */
 if (isImage) {
  return (
   <img
    src={mediaUrl}
    alt={title}
    className="w-full h-full object-contain bg-black"
    loading="lazy"
    onError={(e) => {
     e.currentTarget.onerror = null;
     e.currentTarget.src = "/img/image-error.png";
    }}
   />
  );
 }

 /* ================= FALLBACK ================= */
 return (
  <div className="p-10 text-center text-gray-500">
   <p>Tipo de mídia não suportado ou arquivo não encontrado.</p>
   <a
    href={mediaUrl}
    target="_blank"
    rel="noreferrer"
    className="text-indigo-600 underline text-sm"
   >
    Abrir diretamente
   </a>
  </div>
 );
}

  // =====================================================
  // RENDERIZAÇÃO
  // =====================================================

  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-extrabold text-slate-800 mb-6 pb-3">Central de Comunicação</h1>

      {/* BARRA DE NAVEGAÇÃO DE ABAS */}
      <div className="flex gap-3 mb-8 overflow-x-auto pb-2">
        <div className={tabClass("reviews")} onClick={() => setTab("reviews")}><ReviewsIcon /> Avaliações <span className="text-xs ml-1 font-bold">({lessonReviews.length})</span></div>
        <div className={tabClass("courses")} onClick={() => setTab("courses")}><SettingsIcon /> Cursos <span className="text-xs ml-1 font-bold">({courseCommentSettings.length})</span></div>
        <div className={tabClass("forum")} onClick={() => setTab("forum")}>🗣️ Fórum <span className="text-xs ml-1 font-bold">({threads.length})</span></div>
        <div className={tabClass("publications")} onClick={() => setTab("publications")}>📚 Publicações <span className="text-xs ml-1 opacity-70">({publications.length})</span>
        </div>
         
        <div className={tabClass("gallery")} onClick={() => setTab("gallery")}>📷 Galeria de Fotos <span className="text-xs ml-1 opacity-70">({galleryPhotos.length})</span>
        </div>
        <div className={tabClass("design")} onClick={() => setTab("design")}>
            <DesignIcon /> Design Home
         </div>
        <div className={tabClass("contact")} onClick={() => setTab("contact")}>📧 Contato <span className="text-xs ml-1 font-bold">({contactMessages.length})</span></div>
        <div className={tabClass("chat")} onClick={() => setTab("chat")}>💬 Chat <span className="text-xs ml-1 font-bold">({messages.length})</span></div>
        
      </div>

      <div className="bg-white p-6 rounded-3xl shadow-xl shadow-indigo-100 border border-white">
         
        {/* ABA: REVIEWS (AVALIAÇÕES) */}
        {tab === "reviews" && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1">
              <h2 className="font-bold text-xl text-slate-800 mb-4 border-b pb-3">Avaliações</h2>
              <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
                {lessonReviews.map(r => (
                  <div key={r.id} onClick={() => previewReviewMessage(r)} className={`p-4 border rounded-2xl cursor-pointer transition-all ${previewReview?.id === r.id ? "bg-indigo-50 border-indigo-500 shadow-md transform scale-[1.01]" : "hover:bg-gray-50 border-gray-100"} ${r.is_active !== 1 && 'opacity-60 bg-red-50'}`}>
                    <div className="flex justify-between items-center">
                      <div className="font-bold text-gray-800 truncate">{r.user_name} ({r.rating}/10)</div>
                      <div className="flex items-center gap-2 text-[10px] font-bold">
                        {r.is_active !== 1 && <span className="text-red-500">BLOQUEADO</span>}
                        {r.reply_message && <span className="text-green-600">RESPONDIDO</span>}
                      </div>
                    </div>
                    <div className="text-[10px] text-gray-500 mt-1 truncate">{r.course_title}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:col-span-2">
              {previewReview ? (
                <div className="flex flex-col h-full animate-fadeIn">
                  <div className="flex justify-end gap-3 mb-4">
                    <button onClick={() => confirmBlockReview(previewReview.id, previewReview.is_active === 1)} className={`px-4 py-2 flex items-center gap-2 rounded-lg text-sm font-semibold text-white transition hover:shadow-lg ${previewReview.is_active === 1 ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'}`}>
                      {previewReview.is_active === 1 ? <BlockIcon /> : <CheckIcon />} {previewReview.is_active === 1 ? 'Bloquear' : 'Ativar'}
                    </button>
                    <button onClick={() => confirmDeleteReview(previewReview.id)} className="px-4 py-2 flex items-center gap-2 bg-gray-100 text-red-700 rounded-lg text-sm font-semibold hover:bg-gray-200 hover:text-red-800 transition">
                      <TrashIcon /> Excluir
                    </button>
                  </div>
                  <div className="bg-amber-50 rounded-2xl border border-amber-200 p-6 shadow-sm">
                    <h3 className="font-bold text-amber-900 mb-2">Avaliação de {previewReview.user_name}</h3>
                    <div className="text-lg font-extrabold text-amber-700 mb-4 flex items-center gap-2">
                         Nota: {previewReview.rating}/10 
                         <span className="text-amber-400">{renderRatingStars(previewReview.rating)}</span>
                    </div>
                    <div className="p-4 bg-white rounded-xl border border-amber-100 italic text-sm text-gray-700 leading-relaxed shadow-sm">"{previewReview.message || "(Sem texto)"}"</div>
                  </div>
                  {previewReview.reply_message && (
                    <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl">
                      <div className="text-xs font-bold text-green-700 mb-1 flex items-center gap-2">✅ Resposta do Admin:</div>
                      <div className="text-sm text-gray-700">{previewReview.reply_message}</div>
                    </div>
                  )}
                  <div className="mt-6 border-t pt-4">
                    <textarea className="w-full border border-gray-300 p-4 rounded-xl text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition" rows={3} placeholder="Escreva a resposta..." value={reviewReplyMessage} onChange={e => setReviewReplyMessage(e.target.value)} />
                    <button onClick={() => handleReplyToReview(previewReview)} disabled={!reviewReplyMessage.trim()} className="mt-3 px-6 py-2.5 bg-indigo-600 text-white rounded-xl font-bold flex items-center gap-2 hover:bg-indigo-700 disabled:opacity-50 transition shadow-lg shadow-indigo-200"><SendIcon /> Enviar Resposta</button>
                  </div>
                </div>
              ) : <div className="text-center py-20 text-gray-400 border-2 border-dashed border-gray-200 rounded-2xl bg-gray-50">Selecione uma avaliação para visualizar.</div>}
            </div>
          </div>
        )}

        {/* ABA: COURSES (CONFIGURAÇÕES DE CURSOS) */}
        {tab === "courses" && (
          <div className="animate-fadeIn">
            <h2 className="font-bold text-xl text-slate-800 mb-4 border-b pb-2">Controle de Comentários por Curso</h2>
            <div className="max-h-[70vh] overflow-y-auto rounded-xl border border-gray-200 custom-scrollbar">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">ID</th>
                    <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Nome do Curso</th>
                    <th className="px-6 py-3 text-center text-xs font-bold text-gray-500 uppercase tracking-wider">Status</th>
                    <th className="px-6 py-3 text-center text-xs font-bold text-gray-500 uppercase tracking-wider">Ação</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {courseCommentSettings.map(course => (
                    <tr key={course.id} className="hover:bg-gray-50 transition">
                      <td className="px-6 py-4 text-sm text-gray-500">{course.id}</td>
                      <td className="px-6 py-4 text-sm font-bold text-gray-800">{course.title}</td>
                      <td className="px-6 py-4 text-center">
                        <span className={`px-2 py-1 text-[10px] font-bold rounded-full border ${course.comments_enabled === 1 ? 'bg-green-100 text-green-800 border-green-200' : 'bg-red-100 text-red-800 border-red-200'}`}>
                          {course.comments_enabled === 1 ? 'ATIVO' : 'INATIVO'}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <button onClick={() => confirmToggleCourseComments(course.id, course.comments_enabled)} className={`px-4 py-1.5 text-xs font-bold text-white rounded-lg shadow-md transition transform active:scale-95 ${course.comments_enabled === 1 ? 'bg-red-500 hover:bg-red-600' : 'bg-indigo-500 hover:bg-indigo-600'}`}>
                          {course.comments_enabled === 1 ? 'Desativar' : 'Ativar'}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
{/* ABA: FÓRUM */}
{tab === "forum" && (
  <div className="relative animate-fadeIn"> 
    {/* BOTÃO FECHAR - Posicionado estrategicamente no canto superior */}
    <button
      onClick={() => {
        // Se esta for uma modal de estado (ex: setShowForum(false))
        // ou se você quiser apenas limpar o preview:
        if (typeof setOpenModal === "function") setOpenModal(null);
        else setShowNewThreadModal(false); 
      }}
      className="absolute -top-12 -right-2 md:-right-4 bg-white/10 hover:bg-red-500 text-white w-10 h-10 rounded-full flex items-center justify-center transition-all border border-white/20 shadow-xl z-[100]"
      title="Fechar"
    >
      <span className="text-xl">✕</span>
    </button>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 bg-white rounded-[2rem] p-6 shadow-2xl border border-gray-100">
      
      {/* COLUNA ESQUERDA: LISTA DE TÓPICOS */}
      <div className="lg:col-span-1 border-r border-gray-100 pr-4">
        <button 
          onClick={() => setShowNewThreadModal(true)} 
          className="w-full mb-4 bg-green-600 text-white py-3 rounded-xl font-bold hover:bg-green-700 transition shadow-lg shadow-green-100 flex items-center justify-center gap-2"
        >
          <span>+</span> Novo Tópico
        </button>
        
        <div className="space-y-2 max-h-[65vh] top-0 overflow-y-auto pr-2 custom-scrollbar">
          {threads.map(t => (
            <div 
              key={t.id} 
              onClick={() => previewForumThread(t.id)} 
              className={`p-4 rounded-xl cursor-pointer border transition-all ${
                previewThreadMsgs?.id === t.id 
                ? "bg-indigo-50 border-indigo-500 shadow-sm" 
                : "hover:bg-gray-50 border-gray-100"
              }`}
            >
              <div className="font-bold text-sm truncate text-gray-800">{t.title}</div>
              <div className="text-[10px] text-gray-500 mt-1">{formatDate(t.created_at)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* COLUNA DIREITA: CONTEÚDO E CHAT */}
      <div className="lg:col-span-2">
        {previewThreadMsgs ? (
          <div className="flex flex-col h-[75vh] animate-fadeIn">
            {/* HEADER DO TÓPICO */}
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="font-black text-[#053b50] text-xl leading-tight">
                  {previewThreadMsgs.title}
                </h3>
                <span className="text-[10px] text-gray-400 uppercase font-bold tracking-widest">Discussão Ativa</span>
              </div>
              <div className="flex gap-2">
                <button onClick={() => confirmDeleteThread(previewThreadMsgs.id)} className="px-3 py-1.5 text-[10px] font-bold bg-red-50 text-red-600 rounded-lg flex items-center gap-1 hover:bg-red-600 hover:text-white transition uppercase">
                   Excluir
                </button>
                <button onClick={() => setActionModal({ /* ... */ })} className="px-3 py-1.5 text-[10px] font-bold bg-amber-50 text-amber-600 rounded-lg flex items-center gap-1 hover:bg-amber-500 hover:text-white transition uppercase">
                   Bloquear
                </button>
              </div>
            </div>

            {/* ÁREA DE MENSAGENS (SCROLLABLE) */}
            <div className="flex-1 overflow-y-auto p-4 bg-gray-50 rounded-3xl border border-gray-100 custom-scrollbar mb-4 space-y-4">
              
              {/* Post Original */}
              <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm">
                <div 
                  className="text-sm text-gray-700 prose prose-sm max-w-none"
                  dangerouslySetInnerHTML={{ __html: safeParseContent(previewThreadMsgs.content) }}
                />
                <ImageGroup attachments={previewThreadMsgs.attachments || []} />
              </div>

              {/* Respostas */}
              {previewThreadMsgs.replies?.map(msg => (
                <div key={msg.id} className="relative group">
                  <MessageBubble 
                    isSentByCurrentUser={msg.user_id === currentUserId} 
                    senderName={getUserLabel(msg.author, msg.author_role)} 
                    sentAt={formatDate(msg.created_at)}
                  >
                    <div 
                      className="text-sm prose prose-sm max-w-none"
                      dangerouslySetInnerHTML={{ __html: safeParseContent(msg.content) }} 
                    />
                    <ImageGroup attachments={msg.attachments || []} />
                  </MessageBubble>
                  {canDelete(msg) && (
                    <button 
                      onClick={() => confirmDeleteMessage(msg, "FORUM_REPLY")} 
                      className="absolute top-0 -right-2 opacity-0 group-hover:opacity-100 bg-white text-red-600 p-1.5 rounded-full shadow-md border hover:scale-110 transition-all"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>

            {/* INPUT DE RESPOSTA */}
            <div className="flex gap-3 bg-white p-2 rounded-2xl border border-gray-200 shadow-inner">
              <input 
                className="flex-1 bg-transparent px-4 py-3 text-sm outline-none" 
                placeholder="Escreva sua resposta..." 
                value={replyMessage} 
                onChange={e => setReplyMessage(e.target.value)} 
                onKeyPress={(e) => e.key === 'Enter' && handleReplyToForum()} 
              />
              <button 
                onClick={handleReplyToForum} 
                className="bg-indigo-600 text-white p-3 rounded-xl hover:bg-indigo-700 transition-all active:scale-95 flex items-center justify-center min-w-[50px]"
              >
                ➤
              </button>
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col items-center justify-center text-center p-10 bg-gray-50 border-2 border-dashed border-gray-200 rounded-[2.5rem]">
            <div className="text-4xl mb-4 opacity-20">💬</div>
            <h3 className="text-lg font-bold text-gray-400">Selecione um tópico</h3>
            <p className="text-sm text-gray-400 max-w-xs">Escolha uma discussão ao lado para visualizar as mensagens e participar.</p>
          </div>
        )}
      </div>
    </div>
  </div>
)}
        
       {/* ABA GALERIA COM EDIÇÃO */}
        {tab === "gallery" && (
          <div className="animate-fadeIn">
            <div className="flex justify-between items-center mb-6">
              <h2 className="font-bold text-xl text-slate-800">Galeria Home Slider</h2>
              <button onClick={() => { setPhotoToEdit(null); setShowGalleryModal(true); }} className="bg-indigo-600 text-white px-6 py-2.5 rounded-xl font-bold hover:bg-indigo-700 transition shadow-lg shadow-indigo-200">+ Adicionar Foto</button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {galleryPhotos.map((photo, index) => (
                <div key={photo.id} className="relative group bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
                  <img src={photo.image_url} className="w-full h-40 object-cover cursor-pointer hover:scale-105 transition-transform duration-500" alt="Galeria" onClick={() => setPreviewGalleryIndex(index)} />
                  <div className="p-3 flex justify-between items-center bg-white border-t">
                    <span className="text-xs truncate w-24 font-bold text-gray-700" title={photo.title}>{photo.title}</span>
                    <div className="flex gap-2">
                      <button onClick={() => { setPhotoToEdit(photo); setShowGalleryModal(true); }} className="text-indigo-600 hover:bg-indigo-50 p-1 rounded-md transition">✏️</button>
                      <button onClick={() => setActionModal({ show: true, actionType: 'DELETE_GALLERY', data: { id: photo.id } })} className="text-red-500 hover:bg-red-50 p-1 rounded-md transition"><TrashIcon /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
         
         
      {previewGalleryIndex !== null && galleryPhotos[previewGalleryIndex] && (
       <ImageZoomModal
        src={galleryPhotos[previewGalleryIndex].image_url}
        onClose={() => setPreviewGalleryIndex(null)}
       />
      )}



        {/* ABA: CONTACT (MENSAGENS DE CONTATO) */}
        {tab === "contact" && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1">
              <h2 className="font-bold text-xl text-slate-800 mb-4 border-b pb-3">Mensagens Recebidas</h2>
              <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
                {contactMessages.map(c => (
                  <div key={c.id} onClick={() => previewContactMessage(c)} className={`p-4 border rounded-2xl cursor-pointer transition-all ${previewContact?.id === c.id ? "bg-indigo-50 border-indigo-500 shadow-sm" : "hover:bg-gray-50 border-gray-100"}`}>
                    <div className="font-bold text-gray-800 truncate text-sm">{c.assunto || "Sem Assunto"}</div>
                    <div className="text-[10px] text-gray-500 mt-1">{c.name} — {formatDate(c.created_at)}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:col-span-2">
              {previewContact ? (
                <div className="animate-fadeIn">
                  <div className="bg-indigo-50 p-5 rounded-2xl border border-indigo-100 mb-4 shadow-sm">
                    <div className="text-sm text-indigo-900 mb-1"><strong>De:</strong> {previewContact.name} <span className="text-indigo-600 text-xs">({previewContact.email})</span></div>
                    <div className="text-sm text-indigo-900"><strong>Assunto:</strong> {previewContact.assunto}</div>
                  </div>
                  <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-inner min-h-[150px] text-gray-700 text-sm whitespace-pre-wrap leading-relaxed">{previewContact.message}</div>
                  <div className="mt-6 border-t border-gray-100 pt-4">
                    <label className="font-bold text-gray-800 text-sm">Resposta por E-mail</label>
                    <textarea className="w-full border border-gray-300 p-4 rounded-xl mt-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition" rows={4} placeholder="Escreva o e-mail de resposta..." value={contactReplyMessage} onChange={e => setContactReplyMessage(e.target.value)} />
                    <div className="flex justify-between mt-4">
                      <button onClick={() => confirmDeleteContact(previewContact.id)} className="px-5 py-2 bg-white border border-red-200 text-red-600 rounded-xl text-sm flex items-center gap-2 hover:bg-red-50 transition shadow-sm hover:shadow-md"><TrashIcon /> Excluir Mensagem</button>
                      <button onClick={() => handleReplyToContact(previewContact)} className="px-6 py-2 bg-indigo-600 text-white rounded-xl font-bold flex items-center gap-2 hover:bg-indigo-700 transition shadow-lg shadow-indigo-200"><SendIcon /> Enviar E-mail</button>
                    </div>
                  </div>
                </div>
              ) : <div className="text-center py-20 text-gray-400 border-2 border-dashed border-gray-200 rounded-2xl bg-gray-50">Selecione uma mensagem de contato para visualizar.</div>}
            </div>
          </div>
        )}

        {/* ABA: CHAT (SUPORTE EM TEMPO REAL) */}
        {tab === "chat" && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1">
              <h2 className="font-bold text-xl text-slate-800 mb-4 border-b pb-3">Chats Ativos</h2>
              <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
                {messages.map(chat => (
                  <div key={chat.id} onClick={() => previewChatMessage(chat)} className={`p-4 border rounded-2xl cursor-pointer transition-all ${previewChatMsg?.id === chat.id ? "bg-indigo-50 border-indigo-500 shadow-sm" : "hover:bg-gray-50 border-gray-100"}`}>
                    <div className="flex justify-between items-center">
                      <div className="font-bold text-gray-800 text-sm truncate">Chat com {chat.user_name}</div>
                      {chat.is_blocked === 1 && <span className="text-red-500 text-xs">🔒 Bloqueado</span>}
                    </div>
                    <div className="text-[10px] text-gray-500 mt-1">ID: #{chat.id} — {formatDate(chat.last_message_at)}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:col-span-2 flex flex-col min-h-[75vh]">
              {previewChatMsg ? (
                <div className="flex flex-col h-full animate-fadeIn">
                  <div className="flex justify-between items-center mb-3">
                    <h3 className="font-bold text-lg text-slate-800">Suporte: {previewChatMsg.user_name}</h3>
                    <div className="flex gap-2">
                      <button onClick={() => setActionModal({ show: true, actionType: "TOGGLE_CHAT_BLOCK", modalTitle: previewChatMsg.is_blocked ? "Desbloquear" : "Bloquear", modalContent: "Deseja alterar o acesso do usuário ao chat?", confirmVariant: previewChatMsg.is_blocked ? "primary" : "danger", data: { chatId: previewChatMsg.id, blocked: !previewChatMsg.is_blocked } })} className={`px-3 py-1.5 text-xs rounded-lg font-bold text-white transition shadow ${previewChatMsg.is_blocked ? "bg-green-600 hover:bg-green-700" : "bg-amber-500 hover:bg-amber-600"}`}>
                        {previewChatMsg.is_blocked ? "Desbloquear" : "Bloquear Usuário"}
                      </button>
                      <button onClick={() => setActionModal({ show: true, actionType: "DELETE_CHAT_THREAD", modalTitle: "Excluir Chat", modalContent: "Deseja excluir toda a conversa?", confirmVariant: "danger", data: { chatId: previewChatMsg.id } })} className="px-3 py-1.5 text-xs bg-red-600 text-white rounded-lg font-bold hover:bg-red-700 transition shadow"><TrashIcon /> Limpar</button>
                    </div>
                  </div>
                  <div className="flex-1 overflow-y-auto p-4 bg-slate-50 rounded-2xl border border-gray-200 flex flex-col gap-3 mb-4 custom-scrollbar shadow-inner">
                    {chatHistory.map(msg => (
                      <div key={msg.id} className="relative group">
                        <MessageBubble isSentByCurrentUser={msg.from_admin === 1} senderName={msg.from_admin === 1 ? "Suporte" : previewChatMsg.user_name} sentAt={formatDate(msg.sent_at)}>
                          <div className="text-sm">{msg.message}</div>
                        </MessageBubble>
                        <button onClick={() => setActionModal({ show: true, actionType: "DELETE_CHAT_MSG", modalTitle: "Excluir", modalContent: "Remover esta mensagem?", confirmVariant: "danger", data: { messageId: msg.id } })} className="absolute opacity-0 group-hover:opacity-100 top-0 right-0 bg-white shadow-md rounded-full p-1.5 text-red-600 transition-opacity hover:bg-red-50"><TrashIcon /></button>
                      </div>
                    ))}
                  </div>
                  {previewChatMsg.is_blocked ? (
                    <div className="p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 font-bold text-center">🔒 Chat bloqueado.</div>
                  ) : (
                    <div className="flex gap-2">
                      <textarea className="flex-1 border p-3 rounded-xl text-sm resize-none focus:ring-2 focus:ring-indigo-500 outline-none" rows={2} placeholder="Digite sua mensagem de suporte..." value={chatReplyMessage} onChange={e => setChatReplyMessage(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && handleReplyToChat(previewChatMsg.id)} />
                      <button onClick={() => handleReplyToChat(previewChatMsg.id)} className="bg-indigo-600 text-white px-6 rounded-xl hover:bg-indigo-700 transition shadow-lg shadow-indigo-200"><SendIcon /></button>
                    </div>
                  )}
                </div>
              ) : <div className="text-center py-20 text-gray-400 border-2 border-dashed border-gray-200 rounded-2xl bg-gray-50">Selecione uma conversa ativa.</div>}
            </div>
          </div>
        )}
{/* =====================================================
    ABA: PUBLICAÇÕES (ARTIGOS E CONTEÚDOS)
    ===================================================== */}
{tab === "publications" && (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 animate-fadeIn">
    {/* LISTA LATERAL DE ARTIGOS */}
    <div className="lg:col-span-4 border-r pr-6 border-gray-100">
      <div className="flex flex-col gap-4 mb-6">
        <h2 className="text-xl font-black text-slate-800">Meus Artigos</h2>
        <button
          onClick={() => {
            setPublicationToEdit(null);
            setPreviewPublication(null);
            setShowNewPublicationModal(true);
          }}
          className="w-full bg-indigo-600 text-white py-4 rounded-2xl font-bold hover:bg-indigo-700 transition shadow-lg shadow-indigo-100 flex items-center justify-center gap-2"
        >
          <span className="text-xl">+</span> Criar Novo Artigo
        </button>
      </div>

      <div className="space-y-3 max-h-[65vh] overflow-y-auto pr-2 custom-scrollbar">
        {publications.length === 0 ? (
          <div className="text-sm text-gray-400 text-center py-10 bg-gray-50 rounded-2xl border-2 border-dashed">
            Nenhuma publicação encontrada.
          </div>
        ) : (
          publications.map(pub => (
            <div
              key={pub.id}
              onClick={() => setPreviewPublication(pub)}
              className={`p-4 rounded-2xl cursor-pointer border-2 transition-all duration-300 ${
                previewPublication?.id === pub.id
                  ? "bg-white border-indigo-500 shadow-xl transform scale-[1.02]"
                  : "bg-gray-50 border-transparent hover:bg-white hover:border-gray-200"
              }`}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex gap-1.5">
                  <span className={`px-2 py-0.5 rounded text-[9px] font-black uppercase ${
                    pub.type === "pdf" ? "bg-red-100 text-red-600" : 
                    pub.type === "youtube" ? "bg-blue-100 text-blue-600" : 
                    "bg-green-100 text-green-600"
                  }`}>
                    {pub.type}
                  </span>
                  <span className={`px-2 py-0.5 rounded text-[9px] font-black uppercase ${
                    pub.status === "publicado" ? "bg-green-500 text-white" : 
                    pub.status === "aguardando" ? "bg-amber-400 text-white" : 
                    "bg-gray-400 text-white"
                  }`}>
                    {pub.status === "aguardando" ? "Avaliação" : pub.status}
                  </span>
                </div>
                <span className="text-[10px] text-gray-400 font-bold">{formatDate(pub.created_at)}</span>
              </div>
              <h3 className="font-bold text-gray-800 text-sm line-clamp-2 leading-tight">{pub.title}</h3>
            </div>
          ))
        )}
      </div>
    </div>

    {/* VISUALIZAÇÃO DO CONTEÚDO */}
    <div className="lg:col-span-8">
      {previewPublication ? (
        <article className="max-w-4xl mx-auto animate-fadeIn bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden">
          {/* BARRA DE AÇÕES DO ARTIGO */}
          <div className="p-6 border-b border-gray-50 flex justify-between items-center bg-gray-50/50">
            <div className="flex gap-2">
              <button
                onClick={() => handleEditPublication(previewPublication)}
                className="px-5 py-2 bg-white border border-gray-200 text-gray-700 rounded-xl text-xs font-bold hover:text-indigo-600 hover:border-indigo-200 transition shadow-sm"
              >
                ✏️ Editar
              </button>
              <button
                onClick={() => setActionModal({
                  show: true,
                  actionType: "DELETE_PUBLICATION",
                  modalTitle: "Remover Artigo",
                  modalContent: `Tem certeza que deseja excluir "${previewPublication.title}"?`,
                  confirmVariant: "danger",
                  data: previewPublication
                })}
                className="px-5 py-2 bg-red-50 text-red-600 rounded-xl text-xs font-bold hover:bg-red-600 hover:text-white transition"
              >
                Excluir
              </button>
            </div>
            <div className="flex items-center gap-2 px-3 py-1 bg-white rounded-full border shadow-sm">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
              <span className="text-[10px] font-black text-gray-500 uppercase tracking-widest">{previewPublication.status}</span>
            </div>
          </div>

          <div className="p-8 md:p-12">
            <header className="mb-10 text-center">
              <h1 className="text-4xl font-black text-slate-900 mb-6 leading-tight">{previewPublication.title}</h1>
              <div className="flex items-center justify-center gap-4 text-xs font-bold text-gray-400 uppercase tracking-widest">
                <span>📅 {formatDate(previewPublication.created_at)}</span>
                <span className="text-gray-200">|</span>
                <span className="flex items-center gap-1">📁 {previewPublication.type}</span>
              </div>
            </header>

            {/* ÁREA DE MÍDIA INTEGRADA */}
            <div className="mb-12 rounded-[2rem] overflow-hidden shadow-2xl border-8 border-gray-50 bg-black aspect-video flex items-center justify-center">
              <PublicationMedia
                url={previewPublication.media?.url || previewPublication.media_url || previewPublication.file_url || previewPublication.url}
                type={previewPublication.media?.type || previewPublication.type}
                title={previewPublication.title}
              />
            </div>

            {/* TEXTO DO ARTIGO */}
            <div className="pb-10">
              <div 
                className="prose prose-lg max-w-none text-gray-700 leading-relaxed prose-headings:text-indigo-900 prose-strong:text-slate-900 prose-img:rounded-3xl"
                dangerouslySetInnerHTML={{ __html: previewPublication.content }} 
              />
            </div>
          </div>
        </article>
      ) : (
        <div className="h-full flex flex-col items-center justify-center text-center p-20 bg-gray-50 border-2 border-dashed border-gray-200 rounded-[3rem]">
          <div className="w-20 h-20 bg-white rounded-3xl shadow-xl flex items-center justify-center text-4xl mb-6">📖</div>
          <h3 className="text-xl font-black text-slate-400">Leitor de Publicações</h3>
          <p className="text-gray-400 mt-2 max-w-xs">Selecione um artigo à esquerda para visualizar o conteúdo completo e gerenciar a mídia.</p>
        </div>
      )}
    </div>
  </div>
)}

{/* =====================================================
    ABA: DESIGN (IDENTIDADE VISUAL)
    ===================================================== */}
{tab === "design" && (
  <div className="max-w-5xl mx-auto py-10 animate-fadeIn">
    <div className="text-center mb-12">
      <h2 className="text-4xl font-black text-slate-800 mb-3">Estilo da Plataforma</h2>
      <p className="text-gray-500 font-medium">Personalize a identidade visual que seus alunos verão na Home.</p>
    </div>

    {/* IDENTIDADE DE CORES */}
    <div className="bg-white p-10 rounded-[3rem] border border-gray-100 mb-12 shadow-2xl shadow-indigo-50/50">
      <div className="flex items-center gap-5 mb-10">
        <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-4 rounded-3xl text-white shadow-lg shadow-indigo-100">
          <DesignIcon />
        </div>
        <div>
          <h3 className="font-black text-2xl text-gray-800">Cores Globais</h3>
          <p className="text-sm text-gray-400 font-medium">A cor de fundo impacta toda a experiência visual da Home.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="bg-gray-50 p-8 rounded-[2.5rem] border border-gray-100">
          <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-6 block">Seletor de Cor Principal</label>
          <div className="flex items-center gap-6">
            <input 
              type="color" 
              value={globalSettings.SITE_BACKGROUND_COLOR || "#f8fafc"} 
              onChange={(e) => setGlobalSettings(prev => ({ ...prev, SITE_BACKGROUND_COLOR: e.target.value }))}
              className="w-24 h-24 rounded-[2rem] cursor-pointer border-8 border-white shadow-2xl transition-transform hover:scale-110"
            />
            <div className="flex flex-col gap-3">
              <span className="font-mono font-black text-2xl text-slate-700 tracking-tighter uppercase">
                {globalSettings.SITE_BACKGROUND_COLOR || "#f8fafc"}
              </span>
              <button 
                onClick={() => setActionModal({
                  show: true,
                  actionType: 'UPDATE_DESIGN',
                  modalTitle: "Salvar Identidade Visual",
                  modalContent: "Esta cor será aplicada imediatamente ao fundo da página inicial. Confirmar?",
                  confirmVariant: "primary",
                  data: { payload: { SITE_BACKGROUND_COLOR: globalSettings.SITE_BACKGROUND_COLOR } }
                })}
                className="bg-indigo-600 text-white px-6 py-3 rounded-2xl font-black text-xs hover:bg-indigo-700 transition shadow-xl shadow-indigo-200 active:scale-95"
              >
                APLICAR AGORA
              </button>
            </div>
          </div>
        </div>

        <div className="relative group">
          <div className="absolute -inset-2 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-[2.5rem] blur opacity-10 group-hover:opacity-20 transition duration-1000"></div>
          <div className="relative bg-white rounded-[2rem] border p-6 shadow-inner text-center">
            <p className="text-[10px] text-gray-300 mb-4 uppercase font-black tracking-widest">Visualização em Tempo Real</p>
            <div 
              className="h-32 w-full rounded-2xl border-4 border-white shadow-lg flex items-center justify-center text-sm font-bold text-gray-400"
              style={{ backgroundColor: globalSettings.SITE_BACKGROUND_COLOR || "#f8fafc" }}
            >
              Exemplo de Fundo
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* LAYOUT DA GALERIA */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
{[
  {
    id: 'slider',
    title: 'Design Moderno',
    icon: '✨',
    desc: 'Slider minimalista, cantos ultra arredondados e transições suaves.',
    color: 'indigo'
  },
  {
    id: 'tv',
    title: 'Design Retrô',
    icon: '📺',
    desc: 'Simulação de TV clássica com bordas de madeira e estética vintage.',
    color: 'amber'
  }
].map(mode => {
  // Pega o valor atual do estado
  let currentMode = globalSettings.GALLERY_DESIGN_MODE;
  
  // Se for nulo/undefined, assume 'slider'
  if (!currentMode) currentMode = 'slider';

  // Compara ignorando maiúsculas/minúsculas e espaços
  const isActive = String(currentMode).trim().toLowerCase() === String(mode.id).trim().toLowerCase();

  return (
        <div
            key={mode.id}
            onClick={() => setActionModal({
                show: true,
                actionType: 'UPDATE_DESIGN',
                modalTitle: `Mudar para ${mode.title}`,
                modalContent: `Deseja alterar o layout da galeria da Home para o estilo ${mode.title}?`,
                confirmVariant: "primary",
                data: { payload: { GALLERY_DESIGN_MODE: mode.id } }
            })}
            className={`group p-8 rounded-[3rem] border-4 cursor-pointer transition-all duration-500 ${
                isActive
                ? `border-${mode.color}-500 bg-${mode.color}-50 shadow-2xl scale-[1.03]`
                : 'border-gray-100 bg-white hover:border-gray-200 hover:shadow-xl'
            }`}
        >
            <div className="text-6xl mb-6 group-hover:rotate-12 transition-transform duration-500">{mode.icon}</div>
            <h3 className="font-black text-2xl mb-2 text-slate-800">{mode.title}</h3>
            <p className="text-sm text-gray-500 leading-relaxed mb-8">{mode.desc}</p>
            <div className={`py-4 rounded-2xl text-center text-xs font-black tracking-[0.2em] transition-all ${
                isActive
                ? `bg-${mode.color}-600 text-white shadow-lg`
                : 'bg-gray-100 text-gray-400 group-hover:bg-gray-200'
            }`}>
                {isActive ? 'LAYOUT ATUAL' : 'SELECIONAR'}
            </div>
        </div>
    );
})}
</div>
  </div>
)}      
    
      
      </div>

    {/* MODAL: CRIAR NOVO TÓPICO */}
{showNewThreadModal && (
  <div className="fixed inset-0 z-[99999] flex items-start justify-center bg-black/60 backdrop-blur-sm p-4 pt-10 overflow-y-auto">
    
    {/* CONTAINER DO MODAL */}
    <div className="relative w-full max-w-2xl bg-white rounded-[2.5rem] shadow-2xl animate-modal overflow-hidden">
      
      {/* BOTÃO FECHAR - Flutuante e visível no Header Azul */}
      <button
        onClick={() => setShowNewThreadModal(false)}
        className="absolute top-5 right-5 bg-gray-100 hover:bg-red-500 hover:text-white text-gray-500 w-10 h-10 rounded-full flex items-center justify-center transition-all z-[100]"
      >
        <span className="text-xl">✕</span>
      </button>

      {/* CONTEÚDO DO FORMULÁRIO */}
      <div className="p-8 md:p-10">
        <h2 className="text-3xl font-black text-[#053b50] mb-8">
          Criar novo <span className="text-indigo-600">tópico</span>
        </h2>

        <div className="space-y-6">
          {/* CATEGORIA */}
          <div>
            <label className="text-xs font-black uppercase text-gray-400 tracking-widest mb-2 block">Categoria</label>
            <div className="flex gap-2">
              <select className="flex-1 bg-gray-50 border-none p-4 rounded-2xl text-sm focus:ring-2 focus:ring-indigo-500 outline-none">
                <option>Selecione...</option>
                <option value="boca">Boca</option>
                <option value="cranio">Crânio</option>
                <option value="face">Face</option>
              </select>
              <button className="bg-indigo-600 text-white w-12 h-12 rounded-2xl flex items-center justify-center font-bold">+</button>
            </div>
          </div>

          {/* TAGS */}
          <div>
            <label className="text-xs font-black uppercase text-gray-400 tracking-widest mb-2 block">Tags</label>
            <div className="flex flex-wrap gap-2 mb-3">
              {['Boca', 'Cranio', 'Face'].map(tag => (
                <span key={tag} className="px-4 py-1.5 bg-gray-100 text-gray-600 rounded-full text-xs font-bold border border-gray-200 cursor-pointer hover:bg-indigo-50">
                  {tag}
                </span>
              ))}
              <button className="px-4 py-1.5 bg-indigo-600 text-white rounded-full text-xs font-bold">+ Nova tag</button>
            </div>
            <input 
              className="w-full bg-gray-50 border-none p-4 rounded-2xl text-sm focus:ring-2 focus:ring-indigo-500 outline-none" 
              placeholder="Buscar tag..." 
            />
          </div>

          {/* TÍTULO */}
          <div>
            <label className="text-xs font-black uppercase text-gray-400 tracking-widest mb-2 block">Título</label>
            <input 
              className="w-full bg-gray-50 border-none p-4 rounded-2xl text-sm font-bold focus:ring-2 focus:ring-indigo-500 outline-none" 
              placeholder="Título do tópico" 
            />
          </div>

          {/* MENSAGEM */}
          <div>
            <label className="text-xs font-black uppercase text-gray-400 tracking-widest mb-2 block">Mensagem</label>
            <textarea 
              rows="4"
              className="w-full bg-gray-50 border-none p-4 rounded-2xl text-sm focus:ring-2 focus:ring-indigo-500 outline-none resize-none" 
              placeholder="Descreva o caso ou sua dúvida..."
            />
          </div>

          {/* UPLOAD AREA */}
          <div className="border-2 border-dashed border-gray-200 rounded-[2rem] p-8 text-center bg-gray-50 hover:border-indigo-300 transition-colors cursor-pointer">
            <div className="text-indigo-600 font-bold text-sm">Selecionar arquivos (imagens / PDF)</div>
            <p className="text-[10px] text-gray-400 mt-1 uppercase">Tamanho máximo: 10MB</p>
          </div>

          {/* BOTÕES DE AÇÃO */}
          <div className="flex gap-4 pt-4">
            <button 
              onClick={() => setShowNewThreadModal(false)}
              className="flex-1 py-4 bg-gray-100 text-gray-500 rounded-2xl font-bold hover:bg-gray-200 transition-all"
            >
              Cancelar
            </button>
            <button className="flex-1 py-4 bg-indigo-600 text-white rounded-2xl font-bold hover:bg-indigo-700 shadow-xl shadow-indigo-100 transition-all">
              Publicar Tópico
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
       
      {/* MODAL DE PUBLICAÇÃO (AQUI PASSA O editData) */}
     {showNewPublicationModal && (
       <CreatePublicationModal
        onClose={() => {
         setShowNewPublicationModal(false);
         setPublicationToEdit(null);
        }}
        onSuccess={() => {
         // ✅ fecha modal primeiro
         setShowNewPublicationModal(false);
         setPublicationToEdit(null);
       
         // ✅ carrega publicações UMA vez
         loadPublications();
        }}
        setNotification={setNotification}
        editData={publicationToEdit}
       />
      )}

       {showGalleryModal && (
      <CreateGalleryModal 
        onClose={() => { 
          setShowGalleryModal(false); 
          setPhotoToEdit(null); // Reseta o estado
        }} 
        onSuccess={() => { 
          setShowGalleryModal(false); 
          setPhotoToEdit(null); // Reseta o estado
          loadGallery(); 
        }} 
        setNotification={setNotification}
        editData={photoToEdit}
      />
    )}

    
      {/* MODAL DE CONFIRMAÇÃO GENÉRICO */}
      {actionModal.show && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[10000] animate-fadeIn p-4 backdrop-blur-sm">
          <div className="bg-white rounded-3xl p-8 shadow-2xl w-full max-w-md transform transition-all animate-scaleUp">
            <h2 className={`text-xl font-bold mb-3 ${actionModal.confirmVariant === 'danger' ? 'text-red-600' : 'text-indigo-600'}`}>
              {actionModal.modalTitle}
            </h2>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed">
              {actionModal.modalContent}
            </p>
            <div className="flex justify-end gap-3 border-t pt-5">
              <button className="px-5 py-2.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 font-bold transition text-sm" onClick={() => setActionModal({ show: false })}>Cancelar</button>
              {actionModal.actionType !== 'SMTP_ERROR' && (
                <button className={`px-6 py-2.5 text-white rounded-xl font-bold transition text-sm shadow-lg ${actionModal.confirmVariant === 'danger' ? 'bg-red-600 hover:bg-red-700 shadow-red-200' : 'bg-indigo-600 hover:bg-indigo-700 shadow-indigo-200'}`} onClick={handleActionConfirm}>Confirmar</button>
              )}
            </div>
          </div>
        </div>
      )}

      <audio ref={audioRef} src="https://imagensdaface.com.br/uploads/sons/notify.mp3" preload="auto" />
       <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        iframe { display: block; width: 100%; border: none; }
      `}</style>
    
    </div>
    

  );
}